import React, { FC, useCallback, useMemo, useState } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import {IPoint, Track} from '@consts/types';
import isPositionEqual from '@utils/isPositionEqual'
import MusicFactory from '@utils/MusicFactory'
import Matrix from './parts/matrix'
import palettes from '@consts/palettes';
import soundMap from '@consts/soundMap';
import { Container } from './styleds/root';
import { PlayButton } from './styleds/play-button';
import Pallettewords from '@material-ui/core/Typography';


interface LaunchPadProps {
  onTrackChange: (music: Track) => void
  track: Track | null;
}



const paletteItemsForDD = Object.keys(palettes).map((key) => palettes[key]);
const firstPalette = palettes.default;

const createEmptyTrack = (): Track => ({
  SoundPaletteKey: firstPalette.key,
  soundPosition: [],
})

const LaunchPad: FC<LaunchPadProps> = ({ track, onTrackChange: onMusicChange }) => {
  // const [localTrack, setMusic] = useState<Track>(createEmptyTrack());
  const [selectPalette, setPalette] = useState<string>(track?.SoundPaletteKey || firstPalette.key);

  // useEffect(() => {
  //   setMusic(() => track ?? createEmptyTrack());
  // }, [track, localTrack, setMusic])

  // useEffect(() => {
  //   if (onMusicChange) onMusicChange(localTrack);
  // }, [localTrack, onMusicChange])

  const musicFactory = useMemo(() => new MusicFactory(soundMap), []);

  const onPlay = useCallback(() => {
    const { SoundPaletteKey, soundPosition } = track || createEmptyTrack();
    const { matrix } = palettes[SoundPaletteKey];
    const musicRoad = soundPosition.map(({ x, y }) => {
      const { sound } = matrix[x][y];
      return sound;
    });

    musicFactory.playSong(musicRoad);
  }, [musicFactory, track]);

  // TODO: refactor this fn
  const onToggleCell = useCallback((position: IPoint) => {
    const { SoundPaletteKey, soundPosition } = track || createEmptyTrack();
    const index = soundPosition.findIndex(
      (trackItem) => isPositionEqual(trackItem, position)
    )

    let updateSoundPosition: IPoint[];
    if (index !== -1) {
      updateSoundPosition = [
        ...soundPosition.slice(0, index),
        ...soundPosition.slice(index + 1)
      ]
    } else {
      updateSoundPosition = [
        ...soundPosition,
        position
      ]
    }

    onMusicChange({
      SoundPaletteKey,
      soundPosition: updateSoundPosition
    })
  }, [track, onMusicChange])

  const onChangePalette = useCallback((value: string) => {
    onMusicChange({
      SoundPaletteKey: value,
      soundPosition: []
    });
    setPalette(value);
  }, [setPalette, onMusicChange])

  return (
    <Container>
      <Select
        value={selectPalette}
        onChange={(event) => onChangePalette(event.target.value)}
        fullWidth={true}
      >
        {paletteItemsForDD.map(({ caption, key }) => (
          <MenuItem key={key} value={key} >{caption}</MenuItem>
        ))}
      </Select>
      <Matrix
        matrix={palettes[selectPalette].matrix}
        activeCell={track?.soundPosition ?? []}
        schemeKey={selectPalette}
        onToggleCell={onToggleCell}
      />
      <PlayButton
        onClick={onPlay}
        color='primary'
        variant="contained"
        fullWidth={true}
      >
        Play sound

      </PlayButton>

<p></p>
<p></p>
<p> </p>

        <Pallettewords>  Each pallette includes 9 sounds of different complexity: the lightest colour block (1) is for the single sound and the darkesr/brightest (9) is for the most complex sound in the palette.

 </Pallettewords>
    </Container>


  )
}

export default LaunchPad;
